import comForSeries from '../../../assets/images/production/comForSeries/comForSeries.png'
import leftBall from '../../../assets/images/production/comForSeries/left-ball.png'

import styles from './style.module.scss'

function ComprehensiveForensicsSeries() {
    return (
        <div className={`production-series-wrapper ${styles['com-for-series-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className="title">电子取证产品</div>
                <div className="content">构建多源数据采集接入能力、贴合业务场景的取证分析能力，打造了“多场景、多形态、高性能、高产出” 的电子取证产品体系，满足现场勘查、终端取证、证据分析、电子物证实验室等各类业务场景。</div>
            </div>
            <div className={`series-container ${styles['series-container']}`}>
                <div className={`series-content ${styles['series-content']}`}>
                    <img src={leftBall} alt="" />
                    <div>
                        <div className={styles['series-left']}>
                            <div className={`introduction-title ${styles['introduction-title']}`}>
                                <p><span>综合取证系列</span><span>—— 构建综合、完整、全方位的取证能力</span></p>
                                <p>该系列产品运用多作业并行处理的工作台设计理念，融合手机、硬盘、计算机等多介质取证能力于一体，可满足涉案相关批量设备的信息提取、智能分析、生成报告的取证需求，为案件侦办提供严密、完整、全方位的证据链条。</p>
                            </div>
                            <div className={styles['introduction-container']}>
                                <div className={`introduction-item ${styles['introduction-item']}`}>
                                    <div className={styles['img']}></div>
                                    <div className={styles['introduction-content']}>
                                        <p>安全可靠</p>
                                        <p>支持多重生物认证、围观离位检测、各网域主机间物理隔离</p>
                                    </div>
                                </div>
                                <div className={`introduction-item ${styles['introduction-item']}`}>
                                    <div className={styles['img']}></div>
                                    <div className={styles['introduction-content']}>
                                        <p>并行处理</p>
                                        <p>支持手机取证、计算机取证、远程取证、取证分析等多作业并行处理</p>
                                    </div>
                                </div>
                                <div className={`introduction-item ${styles['introduction-item']}`}>
                                    <div className={styles['img']}></div>
                                    <div className={styles['introduction-content']}>
                                        <p>多形态</p>
                                        <p>支持单主机、双主机、三主机形态，提供多种网络工作环境</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['series-right']}>
                            <img src={comForSeries} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ComprehensiveForensicsSeries